function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// Helper utilities for SettingsModal logic (language parsing/building)
import { ConfigurationAPI } from '../apis/ConfigurationAPI';
import langs from 'langs';
// Preferred name formatting utilities
function capitalizePeriodSeparated(segment) {
    var parts = segment.split('.');
    for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        if (!p)
            continue;
        parts[i] = p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
    }
    return parts.join('.');
}
function capitalizeHyphenated(word) {
    var segments = word.split('-');
    for (var i = 0; i < segments.length; i++) {
        var seg = segments[i];
        if (!seg)
            continue;
        segments[i] = capitalizePeriodSeparated(seg);
    }
    return segments.join('-');
}
export function formatPreferredName(raw) {
    var cleaned = raw.replaceAll(/\s+/g, ' ').trim();
    if (!cleaned)
        return '';
    var words = cleaned.split(' ');
    for (var i = 0; i < words.length; i++) {
        words[i] = capitalizeHyphenated(words[i]);
    }
    return words.join(' ');
}
// Helper: Resolve language code via legacy fallback with uniqueness check.
function deriveLegacyLanguageCode(name, used) {
    var cleaned = name.replaceAll(/[^A-Za-z]/g, '').toLowerCase() || 'lg';
    var base = cleaned.slice(0, 2);
    var code = base;
    var attempt = 2;
    while (used.has(code)) {
        code = base + attempt;
        attempt++;
    }
    used.add(code);
    return code;
}
// Resolve a stable ISO 639-1 code from a language label using the langs library.
// Falls back to legacy derivation for unknown labels.
export function resolveLanguageCode(name) {
    var _lang$;
    var used = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    var key = name.trim();
    // Try to find language by name using langs library
    var lang = langs.where('name', key);
    var iso = lang === null || lang === void 0 || (_lang$ = lang['1']) === null || _lang$ === void 0 ? void 0 : _lang$.toLowerCase();
    if (iso) {
        used.add(iso);
        return iso;
    }
    // fallback to previous derive behavior (kept minimal) ensuring uniqueness
    return deriveLegacyLanguageCode(name, used);
}
// Safely parse a raw supported_language value into an array of strings
export function parseSupportedLanguageValue(raw) {
    var parsed = null;
    // Match strings starting with '[' or '{' to attempt JSON parse; '[' does not need escaping inside the class.
    if (/^[[{]/.test(raw)) {
        try {
            parsed = JSON.parse(raw);
        }
        catch (_unused) {
            parsed = null;
        }
    }
    if (Array.isArray(parsed)) {
        return parsed.filter(function (x) {
            return typeof x === 'string';
        }).map(function (x) {
            return x.trim();
        });
    }
    return raw.split(',').map(function (x) {
        return x.trim();
    }).filter(Boolean);
}
// Build option list from names & ensure current selection present
export function buildLanguageOptions(names, currentSelected, existingSelected) {
    var _ref;
    var unique = Array.from(new Set(names));
    var used = new Set();
    var opts = unique.map(function (n) {
        return {
            code: resolveLanguageCode(n, used),
            label: n
        };
    });
    // Normalize selected to lowercase ISO if present
    var selRaw = ((_ref = currentSelected !== null && currentSelected !== void 0 ? currentSelected : existingSelected) !== null && _ref !== void 0 ? _ref : 'en').trim();
    var selNorm = selRaw.toLowerCase();
    if (!opts.some(function (o) {
        return o.code === selNorm;
    })) {
        opts.push({
            code: selNorm,
            label: selRaw
        });
    }
    opts.sort(function (a, b) {
        return a.label.localeCompare(b.label);
    });
    console.log('Built language options:', opts, 'Selected:', selNorm);
    return {
        options: opts,
        selected: selNorm
    };
}
// Extract language names from a configuration item
function extractLanguageNames(item) {
    if (item.value == null)
        return [];
    var raw = (typeof item.value === 'string' ? item.value : JSON.stringify(item.value)).trim();
    if (!raw)
        return [];
    return parseSupportedLanguageValue(raw);
}
// Extract all supported language names from configuration resources
function getAllLanguageNames(resources) {
    return resources.flatMap(function (resource) {
        return resource.items.filter(function (item) {
            return item.key === 'supported_language';
        }).flatMap(extractLanguageNames);
    });
}
// Fetch remote configurations and return language options. Throws on failure.
export function fetchSupportedLanguagesData(_x, _x2) {
    return _fetchSupportedLanguagesData.apply(this, arguments);
}
// Check if currentLang is a valid language label (name)
function _fetchSupportedLanguagesData() {
    _fetchSupportedLanguagesData = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(currentSelected, existingSelected) {
        var _bundle$resource;
        var bundle, names;
        return _regenerator().w(function (_context) {
            while (1)
                switch (_context.n) {
                    case 0:
                        _context.n = 1;
                        return ConfigurationAPI.getConfigurations('AppConfiguration');
                    case 1:
                        bundle = _context.v;
                        if ((_bundle$resource = bundle.resource) !== null && _bundle$resource !== void 0 && _bundle$resource.some(function (r) {
                            return r.type === 'AppConfiguration';
                        })) {
                            _context.n = 3;
                            break;
                        }
                        _context.n = 2;
                        return ConfigurationAPI.getConfigurations();
                    case 2:
                        bundle = _context.v;
                    case 3:
                        names = getAllLanguageNames(bundle.resource);
                        console.log('Fetched supported languages:', names);
                        return _context.a(2, buildLanguageOptions(names, currentSelected, existingSelected));
                }
        }, _callee);
    }));
    return _fetchSupportedLanguagesData.apply(this, arguments);
}
function validateLanguageByName(currentLang) {
    var langByName = langs.where('name', currentLang);
    if (langByName) {
        return {
            options: [{
                    code: langByName['1'] || currentLang.toLowerCase(),
                    label: currentLang
                }],
            selected: langByName['1'] || currentLang.toLowerCase()
        };
    }
    return null;
}
// Check if currentLang is a valid language code
function validateLanguageByCode(currentLang) {
    var langByCode = langs.where('1', currentLang.toLowerCase());
    if (langByCode) {
        return {
            options: [{
                    code: currentLang.toLowerCase(),
                    label: langByCode.name
                }],
            selected: currentLang.toLowerCase()
        };
    }
    return null;
}
// Build fallback options when remote fetch fails.
export function buildFallbackLanguageOptions(currentSelected, existingSelected) {
    var _ref2;
    var currentLang = (_ref2 = currentSelected !== null && currentSelected !== void 0 ? currentSelected : existingSelected) !== null && _ref2 !== void 0 ? _ref2 : 'en';
    var byNameResult = validateLanguageByName(currentLang);
    if (byNameResult)
        return byNameResult;
    var byCodeResult = validateLanguageByCode(currentLang);
    if (byCodeResult)
        return byCodeResult;
    // Fallback to English if neither valid label nor code
    return {
        options: [{
                code: 'en',
                label: 'English'
            }],
        selected: 'en'
    };
}
// Message Channel utilities
/**
 * Fetch enabled message channels from AppConfiguration
 * Returns array of channel objects with key (for backend) and label (for UI)
 */
export function fetchEnabledMessageChannels() {
    return _fetchEnabledMessageChannels.apply(this, arguments);
}
/**
 * Build default message preferences object based on enabled channels
 * All channels default to false
 */
function _fetchEnabledMessageChannels() {
    _fetchEnabledMessageChannels = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
        var bundle, _iterator2, _step2, config, channelItem, channels, _t, _t2;
        return _regenerator().w(function (_context2) {
            while (1)
                switch (_context2.p = _context2.n) {
                    case 0:
                        _context2.p = 0;
                        _context2.n = 1;
                        return ConfigurationAPI.getConfigurations('AppConfiguration');
                    case 1:
                        bundle = _context2.v;
                        _iterator2 = _createForOfIteratorHelper(bundle.resource || []);
                        _context2.p = 2;
                        _iterator2.s();
                    case 3:
                        if ((_step2 = _iterator2.n()).done) {
                            _context2.n = 6;
                            break;
                        }
                        config = _step2.value;
                        if (!((config === null || config === void 0 ? void 0 : config.type) !== 'AppConfiguration')) {
                            _context2.n = 4;
                            break;
                        }
                        return _context2.a(3, 5);
                    case 4:
                        // Look for "messageChannels" configuration
                        channelItem = config.items.find(function (item) {
                            return (item === null || item === void 0 ? void 0 : item.key) === 'messageChannels';
                        });
                        if (!(channelItem !== null && channelItem !== void 0 && channelItem.value)) {
                            _context2.n = 5;
                            break;
                        }
                        if (!Array.isArray(channelItem === null || channelItem === void 0 ? void 0 : channelItem.value)) {
                            _context2.n = 5;
                            break;
                        }
                        channels = channelItem === null || channelItem === void 0 ? void 0 : channelItem.value.filter(function (ch) {
                            return ch && _typeof(ch) === 'object' && 'key' in ch && 'label' in ch && 'enabled' in ch && typeof (ch === null || ch === void 0 ? void 0 : ch.key) === 'string' && typeof (ch === null || ch === void 0 ? void 0 : ch.label) === 'string' && (ch === null || ch === void 0 ? void 0 : ch.enabled) === true;
                        } // Only include enabled channels
                        ).map(function (ch) {
                            return {
                                key: ch === null || ch === void 0 ? void 0 : ch.key,
                                label: ch === null || ch === void 0 ? void 0 : ch.label,
                                enabled: ch === null || ch === void 0 ? void 0 : ch.enabled
                            };
                        });
                        return _context2.a(2, channels);
                    case 5:
                        _context2.n = 3;
                        break;
                    case 6:
                        _context2.n = 8;
                        break;
                    case 7:
                        _context2.p = 7;
                        _t = _context2.v;
                        _iterator2.e(_t);
                    case 8:
                        _context2.p = 8;
                        _iterator2.f();
                        return _context2.f(8);
                    case 9:
                        return _context2.a(2, []);
                    case 10:
                        _context2.p = 10;
                        _t2 = _context2.v;
                        console.error('Failed to fetch enabled message channels:', _t2);
                        // Return empty array on error - UI will hide message preferences section
                        return _context2.a(2, []);
                }
        }, _callee2, null, [[2, 7, 8, 9], [0, 10]]);
    }));
    return _fetchEnabledMessageChannels.apply(this, arguments);
}
export function buildDefaultMessagePreferences(enabledChannels) {
    var preferences = {};
    var _iterator = _createForOfIteratorHelper(enabledChannels), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var channel = _step.value;
            preferences[channel.key] = false;
        }
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
    return preferences;
}
